<section class="offer" [class.offer--mirror]="order % 2 !== 0" #offerCardRef>
  <img
    class="offer__img"
    [src]="offer?.seo | seoImageUrl: { text: false, format: 'rectangle', logo: true, category: offer?.__typename }"
    [alt]="offer?.seo?.title"
    [title]="offer?.seo?.title"
  />
  <article class="offer__card">
    <div class="offer__card__details">
      <div class="offer__card__details__container">
        <p class="offer__card__details__container__title reveal">{{ offer?.duration }}</p>
        <h2 class="offer__card__details__container__subtitle">{{ 'offerPage.characteristics.duration.label' | translate }}</h2>
      </div>
      <div class="offer__card__details__container">
        <h2 class="offer__card__details__container__title reveal">{{ offer?.budget }}</h2>
        <p class="offer__card__details__container__subtitle">{{ 'offerPage.characteristics.budget.label' | translate }}</p>
      </div>
      <div class="offer__card__details__container">
        <h2 class="offer__card__details__container__title reveal">{{ offer?.team }}</h2>
        <p class="offer__card__details__container__subtitle">{{ 'offerPage.characteristics.team.label' | translate }}</p>
      </div>
    </div>
    <header class="offer__card__view">
      <h4 class="offer__card__view__title">{{ offer?.seo?.title }}</h4>
      <p class="offer__card__view__description">{{ offer?.seo?.description }}</p>
      <a class="offer__card__view__link" placeme-fat-button [routerLink]="['/', 'offers', offer?.slug] | localize">
        {{ 'offersPage.card.ctaLabel' | translate }}</a
      >
    </header>
  </article>
</section>
